import styles from './RenameInput.module.css';
import { isImeComposing } from '@utils/ime';

export interface IRenameInputProps {
  value: string;
  error: string | null;
  /** The immutable extension shown after the input (files only). */
  suffix?: string;
  onChange: (value: string) => void;
  onCommit: () => void;
  onCancel: () => void;
}

/**
 * The inline name editor every documents surface shares — rows and cards,
 * files and folders, renaming and naming a new folder. Commits on Enter or
 * blur, cancels on Escape; the caller owns the value and the validation.
 */
export function RenameInput({ value, error, suffix, onChange, onCommit, onCancel }: IRenameInputProps) {
  return (
    <>
      <span className={styles.field}>
        <input
          className={`${styles.input} ${error ? styles.inputError : ''}`}
          value={value}
          autoFocus
          aria-invalid={error ? true : undefined}
          onFocus={(e) => e.target.select()}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onCommit}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isImeComposing(e)) { e.preventDefault(); onCommit(); }
            if (e.key === 'Escape') { e.preventDefault(); onCancel(); }
          }}
          onClick={(e) => e.stopPropagation()}
        />
        {suffix && <span className={styles.suffix}>{suffix}</span>}
      </span>
      {error && <span className={styles.error} role="alert">{error}</span>}
    </>
  );
}
